import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ListLayout from "../../Layout/PageLayout/ListLayout";
import CategorySubcategoryList from "./CategorySubcategoryList";
 
  
const CategoryList = () => {
  const navigate = useNavigate();
   
  return (
    <ListLayout
        title="Cat-Sub List"
        // searchValue={search}
        // onSearch={handleSearch}
        // onClearSearch={() => handleSearch("")} 
        // onNewText="Submit"   
        // onNewLoading={submitLoading}     
        onNew={(e) => {
          navigate('/admin/catg-sub')
        }}
         
      >
      <CategorySubcategoryList/>
       
    </ListLayout>
  );
};

export default CategoryList;